import React, { useState } from 'react';
import '../App.css';

const Contact = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [status, setStatus] = useState({ type: '', message: '' });
    const [isSending, setIsSending] = useState(false);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!formData.name || !formData.email || !formData.message) {
            setStatus({
                type: 'error',
                message: 'Please fill in your name, email, and message.'
            });
            return;
        }

        const API_URL = 'https://dev-socket.shopysync.com';
        const payload = {
            name: formData.name,
            email: formData.email,
            subject: formData.subject || 'Support Request',
            message: formData.message
        };

        try {
            setIsSending(true);
            setStatus({ type: '', message: '' });

            const requestUrl = `${API_URL}/enquire`;
            console.log('Sending request to:', requestUrl);
            console.log('Payload:', payload);

            const response = await fetch(requestUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(payload)
            });

            console.log('Response Status:', response.status, response.statusText);
            console.log('Response Headers:', response.headers);

            const contentType = response.headers.get('content-type');
            let data;

            if (contentType && contentType.includes('application/json')) {
                const text = await response.text();
                console.log('Response Text:', text);
                
                if (text) {
                    try {
                        data = JSON.parse(text);
                    } catch (parseError) {
                        console.error('JSON Parse Error:', parseError);
                        throw new Error('Invalid response from server. Please try again later.');
                    }
                } else {
                    data = { success: response.ok };
                }
            } else {
                const text = await response.text();
                console.log('Non-JSON Response:', text);
                throw new Error('Server returned an unexpected response format.');
            }

            if (!response.ok) {
                throw new Error(data.error || data.message || `Server error: ${response.status} ${response.statusText}`);
            }

            if (!data.success) {
                throw new Error(data.error || data.message || 'Unable to send message right now. Please try again later.');
            }

            setStatus({
                type: 'success',
                message: data.message || 'Message sent! We will reply to your email shortly.'
            });
            setFormData({ name: '', email: '', subject: '', message: '' });
        } catch (error) {
            console.error('Error details:', error);
            
            let errorMessage = 'Unable to send message right now. Please try again later.';
            
            if (error.message) {
                errorMessage = error.message;
            } else if (error.name === 'TypeError' && error.message.includes('fetch')) {
                errorMessage = 'Cannot connect to server. Please check your connection.';
            } else if (error.name === 'NetworkError' || error.message.includes('Failed to fetch')) {
                errorMessage = 'Network error. Please check your connection.';
            }
            
            setStatus({
                type: 'error',
                message: errorMessage
            });
        } finally {
            setIsSending(false);
        }
    };

    return (
        <section className="py-5 ">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="col-lg-10">

                        <div className="text-center mb-5">
                            <h1 className="fw-bold text-teal display-4">Contact Us</h1>
                            <p className="lead text-muted">
                                Need help? We're just an email away.
                            </p>
                        </div>

                        <div className="row justify-content-center">
                            <div className="col-lg-8">
                                <div className="card border-0 shadow-lg p-5 h-100">
                                    <h5 className="fw-bold mb-4 text-teal">Send us a message</h5>
                                    <form onSubmit={handleSubmit} className="row g-3">
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Name *</label>
                                            <input
                                                type="text"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                className="form-control"
                                                placeholder="Your full name"
                                                required
                                            />
                                        </div>
                                        <div className="col-md-6">
                                            <label className="form-label fw-semibold">Email *</label>
                                            <input
                                                type="email"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                className="form-control"
                                                placeholder="you@example.com"
                                                required
                                            />
                                        </div>
                                        <div className="col-12">
                                            <label className="form-label fw-semibold">Subject</label>
                                            <input
                                                type="text"
                                                name="subject"
                                                value={formData.subject}
                                                onChange={handleChange}
                                                className="form-control"
                                                placeholder="How can we help?"
                                            />
                                        </div>
                                        <div className="col-12">
                                            <label className="form-label fw-semibold">Message *</label>
                                            <textarea
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                className="form-control"
                                                rows="5"
                                                placeholder="Tell us more about your question or issue"
                                                required
                                            ></textarea>
                                        </div>
                                        <div className="col-12">
                                            <button
                                                type="submit"
                                                className="btn btn-teal text-white px-4 py-2"
                                                style={{
                                                    borderRadius: '12px',
                                                    fontWeight: '600',
                                                    boxShadow: '0 4px 12px rgba(13, 110, 110, 0.25)'
                                                }}
                                                disabled={isSending}
                                            >
                                                {isSending ? 'Sending...' : 'Send Message'}
                                            </button>
                                        </div>
                                        {status.message && (
                                            <div className="col-12">
                                                <div
                                                    className={`alert ${status.type === 'error' ? 'alert-danger' : 'alert-success'} mb-0`}
                                                    role="alert"
                                                >
                                                    {status.message}
                                                </div>
                                            </div>
                                        )}
                                    </form>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </section>
    );
};

export default Contact;